import React, { useState, useEffect } from "react";
import { Progress } from 'react-sweet-progress';
import "react-sweet-progress/lib/style.css";
import CardTeachingPreview from "../../components/Card/CardTeachingPreview";
import { Link, useHistory, useLocation } from 'react-router-dom';
import { serverUrl } from "../../components/Helpers/Config";
import axios from 'axios';
import moment from 'moment';
import { addAttribute, htmlToText, trimString } from "../../components/Helpers/Common";
import { BgBlue, TextGray } from "../Theme";
import { useDispatch, useSelector } from "react-redux";

export default function TeachingPreview(props) {
    //const data = props.location.state.list;
    const history = useHistory();
    const location = useLocation();
    // const id = props.match.params.id;
    const isDefaultTheme = useSelector(state => state.auth.isDefaultTheme);
    const userTheme = useSelector(state => state.auth.theme);
    const [data, setData] = useState({
        name: '',
        desc: '',
        due: '',
        icon: '',
        count: 0,
        tasks: [],
    })

    const preview = useSelector((state) => state.teaching.preview);

    useEffect(() => {
        setData({
            name: preview.name,
            course: preview.group_name,
            desc: preview.desc,
            due: moment(preview.date).format("DD/MM/YYYY"),
            created: moment(data.list_created).format("DD/MM/YYYY"),
            icon: moment(preview.date).date(),
            tasks: preview.tasks,
            count: preview.tasks.length > 0 ? Math.floor(Math.random() * preview.tasks.length) : 0
        })
    }, []);

    const goBack = () => {
        const prevPage = (location.state && location.state.src != '/teaching/new') ? location.state.src : '/teaching/new';
        const tabId = (location.state && location.state.tabId) ? location.state.tabId : -1;
        history.push(prevPage, { tabId });
    }


    return (
        <div className='md:px-10 py-3 md:py-5'>
            <div className='flex flex-col mt-4 text-sm px-5 md:px-0 whitespace-nowrap'>
                <p className='px-6 md:px-10 text-sm md:mb-2'>{data.course}</p>
                <div className='flex flex-col md:flex-row' >
                    <div className="flex flex-row self-center cursor-pointer" onClick={goBack}>
                        {/* <Link to='/tasks'> */}
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                        </svg>
                        {/* </Link> */}
                        <p className='font-semibold flex items-center text-2xl md:ml-4 mr-3 md:mr-8'>{data.name}</p>
                    </div>

                    <div className="flex flex-row mt-3 md:mt-0">
                        <div className="flex flex-row">
                            <Progress
                                type="circle"
                                percent={data.tasks.length > 0 ? Math.floor(data.count / data.tasks.length * 100) : 0}
                                width={35}
                                status="success"
                                theme={{
                                    success: {
                                        symbol: (data.tasks.length > 0 ? Math.floor(data.count / data.tasks.length * 100) : 0) + '%',
                                        trailColor: '#EFEFEF',
                                        color: isDefaultTheme == false ? userTheme?.color2 : '#66D692'
                                    }
                                }}
                            />
                            <p className='ml-2 self-center'>{data.count}/{data.tasks.length} task completed</p>
                        </div>
                        <div className="flex flex-row">
                            <div className='w-10 ml-3 md:ml-8 flex flex-wrap content-center justify-center calendar'>
                                <p className='text-blue-500 font-semibold pt-2'>{data.icon}</p>
                            </div>
                            <p className='ml-2 mr-1 self-center'>Due on </p>
                            <p className='font-semibold self-center'>{data.due}</p>
                        </div>
                    </div>
                </div>

                <div
                    className="mt-8 text-viewer break-words whitespace-normal"
                    dangerouslySetInnerHTML={{
                        __html: addAttribute(data.desc)
                    }} />
            </div>
            <BgBlue className='bg-blue-no-hover py-4 mt-8 text-white  justify-between rounded-md hidden md:flex'>
                <p className='w-1/5 text-center'>Task</p>
                <p className='w-3/5 text-center'>Details</p>
                <div className='w-1/5 flex justify-end mr-8'>
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z" />
                    </svg>
                </div>
            </BgBlue>
            {(data.tasks.length > 0 && data.tasks.map((list, index) => (
                <CardTeachingPreview
                    key={index}
                    data={{
                        id: list.id,
                        name: list.task_name,
                        completed: list.response_status,
                        action: list.response_type ? list.response_type : 0,
                        detail: list.task_detail || "",
                        attachments: list.attachment_link || []
                    }}
                // onPostUpdate={refreshData}
                />
            ))) || null}

        </div>
    )
}